module.exports = __webpack_public_path__ + "img/BT.960bc805.svg";